import React, { useState } from 'react';
import { TextField, RadioGroup, FormControlLabel, Radio, Select, MenuItem } from '@mui/material';
import { mostrarInfo } from '../utils/Alertas';
import Modal from './secondary/Modal';
import '../css/GenerarEquipos.css';

const GenerarEquipos: React.FC = () => {
	const [nombresInput, setNombresInput] = useState('');
	const [modo, setModo] = useState<'equipos' | 'personas'>('equipos');
	const [cantidadEquipos, setCantidadEquipos] = useState(2);
	const [personasPorGrupo, setPersonasPorGrupo] = useState(2);
	const [grupos, setGrupos] = useState<string[][]>([]);
    const [mostrarModalResultado, setMostrarModalResultado] = useState(false);

    const totalParticipantes = nombresInput
        .split('\n')
        .map((n) => n.trim())
        .filter((n) => n !== '').length;

	const mezclarArray = (array: string[]) => {
		return [...array].sort(() => Math.random() - 0.5);
	};

	const generarGrupos = () => {
		const nombres = nombresInput
			.split('\n')
			.map((n) => n.trim())
			.filter((n) => n !== '');

		if (nombres.length < 2) {
            return mostrarInfo('Debes ingresar al menos 2 nombres.');
        }

		const nombresMezclados = mezclarArray(nombres);
		const resultado: string[][] = [];

		if (modo === 'equipos') {
			const equipos = cantidadEquipos;
			for (let i = 0; i < equipos; i++) {
				resultado.push([]);
			}
			nombresMezclados.forEach((nombre, index) => {
				resultado[index % equipos].push(nombre);
			});
		} else {
			const personasGrupo = personasPorGrupo;
			for (let i = 0; i < nombresMezclados.length; i += personasGrupo) {
				resultado.push(nombresMezclados.slice(i, i + personasGrupo));
			}
		}

		setGrupos(resultado);
        setMostrarModalResultado(true);
	};

    const cerrarModal = () => setMostrarModalResultado(false);

    const limpiarFormulario = () => {
        setNombresInput('');
        setModo('equipos');
        setCantidadEquipos(2);
        setPersonasPorGrupo(2);
        setGrupos([]);
        setMostrarModalResultado(false);
    };

	return (
        <div className="container-fluid">
            <div className="text-center">
				<h2>Generador de equipos</h2>
            </div>

            <div className="form-equipos container-fluid">
                <TextField
                    label="Introduce los nombres (uno por línea)"
                    multiline
                    fullWidth
                    rows={7}
                    value={nombresInput}
                    onChange={(e) => setNombresInput(e.target.value)}
                    sx={{ mb: 2 }}
                />

                <RadioGroup
                    row
                    value={modo}
                    onChange={(e) => setModo(e.target.value as 'equipos' | 'personas')}
                >
                    <FormControlLabel
                        value="equipos"
                        control={<Radio />}
                        label="Cantidad de equipos"
                    />
                    <FormControlLabel
                        value="personas"
                        control={<Radio />}
                        label="Personas por grupo"
                        sx={{ mb: 2 }}
                    />
                </RadioGroup>

                {modo === 'equipos' ? (
                    <div className="mb-2">
                        <Select value={cantidadEquipos} onChange={(e) => setCantidadEquipos(Number(e.target.value))} fullWidth                        >
                            {Array.from({ length: 8 }, (_, i) => i + 2).map((num) => (
                                <MenuItem key={num} value={num}>
                                    {num} equipos
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                ) : (
                    <div className="mb-2">
                        <Select value={personasPorGrupo} onChange={(e) => setPersonasPorGrupo(Number(e.target.value))} fullWidth>
                            {Array.from({ length: 8 }, (_, i) => i + 2).map((num) => {
                                const equiposCalculados = num > 0 ? Math.ceil(totalParticipantes / num) : 0;
                                return (
                                    <MenuItem key={num} value={num}>
                                        {num} participantes/equipo - ({equiposCalculados} equipos)
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </div>
                )}

                <button className="main-button" onClick={generarGrupos}>Generar equipos</button>
                <button className="reset-button" onClick={limpiarFormulario}>Limpiar</button>
            </div>

			{mostrarModalResultado && (
                <Modal onClose={cerrarModal}>
                    <div className="resultado-content">
                        <div className="resultado-header">
                            <h2>Equipos generados</h2>
                        </div>

                        <div className="resultado-body">
                            {grupos.map((grupo, index) => (
                                <div className="grupo-card" key={index}>
                                    <h4>Equipo {index + 1}</h4>
                                    <ul>
                                        {grupo.map((nombre, idx) => (
                                            <li key={idx}>{nombre}</li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>

                        <p className="resultado-footer">Total de equipos: {grupos.length}</p>
                    </div>
                </Modal>
            )}
		</div>
	);
};

export default GenerarEquipos;
